import { connect } from 'react-redux';
import BigBlueButton from './BigBlueButton';
import { selectors } from '../../../../store/bbb';
import launchMeeting from '../../../../actions/bbb/launchMeeting.action';

const mapStateToProps = (state, ownProps) => ({
  launchingMeeting: selectors.isFetchingJoinUrl(state),
  description: selectors.description(state, ownProps),
});

const mapDispatchToProps = (dispatch, { id, context }) => ({
  launchMeeting: () => dispatch(launchMeeting({ id, context })),
});

export default connect(mapStateToProps, mapDispatchToProps)(BigBlueButton);
